import React from 'react';
import { useReportStore } from '../../../../store/reportStore';
import { MathsReport } from './MathsReport';
import { EnglishReport } from './EnglishReport';
import { OtherReport } from './OtherReport';

export const ReportContent: React.FC = () => {
  const { activeTab } = useReportStore();

  const reports = {
    maths: <MathsReport />,
    english: <EnglishReport />,
    other: <OtherReport />
  };

  return reports[activeTab];
};